import { observer } from 'mobx-react-lite';
import React from 'react';

import { useConfig } from '../../hooks';
import { useStores } from '../../stores';
import { ControlsItem } from '../Header/Controls';
import IconButton from '../IconButton';
import HomeIcon from '../Icons/Home';

const HomeButton = (props, ref) => {
  const {
    window: { buttonsColor },
    overlapMenu: {
      options: { homeButtonEnabled }
    }
  } = useConfig();
  const { ui, chat } = useStores();

  if (!ui.isHomeButton || !homeButtonEnabled) return null;

  return (
    <ControlsItem ref={ref} {...props}>
      <IconButton onClick={() => ui.closeOverlapMenuModal()} disabled={chat.isMessaging}>
        <HomeIcon fill={buttonsColor} />
      </IconButton>
    </ControlsItem>
  );
};

export default observer(HomeButton, { forwardRef: true });
